import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Spinner from "./views/Spinner/Spinner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    {/* <React.Suspense fallback={<Spinner />}> */}
    <App />
    {/* </React.Suspense> */}
  </BrowserRouter>
  // </React.StrictMode>
);

